/**
 * Un composant unique pour gérer tous les champs "Proxy" (Input vers Tags Shopify)
 */
class BaseProxyInput extends HTMLElement {
  constructor() {
    super();
    this._init();
  }

  _init() {
    // On récupère les éléments
    this.hiddenInput = this.querySelector('[id^="fake-"]');
    this.checkboxes = this.querySelectorAll('.interested-checkbox');
    // On cible l'input de saisie en excluant le fake et le select pays
    this.realInput = this.querySelector('input:not([type="hidden"]), textarea, select:not(#phone_country)');
    this.countrySelect = this.querySelector('#phone_country');

    if (!this.hiddenInput) return;

    // Events
    if (this.checkboxes.length > 0) {
      this.checkboxes.forEach(cb => cb.addEventListener('change', () => this.update()));
    } else if (this.realInput) {
      this.realInput.addEventListener('input', () => this.update());
      this.realInput.addEventListener('change', () => this.update());
    }

    if (this.countrySelect) {
      this.countrySelect.addEventListener('change', () => this.update());
    }
    
    this.update();
  }

  getRawValue() {
    // Cas spécifique : Phone
    if (this.tagName.toLowerCase() === 'phone-input') {
      const code = this.countrySelect?.value || '';
      const phone = this.realInput?.value.trim() || '';
      return phone !== '' ? `${code}${phone}` : '';
    }

    // Cas spécifique : Checkboxes
    if (this.checkboxes.length > 0) {
      return Array.from(this.checkboxes)
        .filter(cb => cb.checked)
        .map(cb => cb.value)
        .join(',');
    }

    return this.realInput?.value.trim() || '';
  }

  update() {
    const val = this.getRawValue();
    const prefix = this.hiddenInput.dataset.initValue || '';

    if (val !== '') {
      this.hiddenInput.value = `${prefix}${val}`;
      this.hiddenInput.setAttribute('data-validate', 'true');
    } else {
      this.hiddenInput.value = '';
      this.hiddenInput.setAttribute('data-validate', 'false');
    }
  }
}

const components = [
  'vat-input', 'company-input', 'morel-input', 'business-type-input', 
  'interested-input', 'address-input', 'address2-input', 'zip-input', 
  'city-input', 'country-input', 'phone-input', 'additional-comments'
];

components.forEach(tag => {
  if (!customElements.get(tag)) {
    customElements.define(tag, class extends BaseProxyInput {});
  }
});

/**
 * Gestionnaire du Formulaire de Registre
 */
class RegisterForm extends HTMLElement {
  constructor() {
    super();
    this.form = this.querySelector('form');
    this.submitBtn = this.querySelector('button.form__submit');
    this.tagsInput = this.querySelector('#customer-tags');
    
    this.submitBtn.addEventListener('click', (e) => this.handleSubmit(e));
    this.moveSuccessBanner();
  }

  moveSuccessBanner() {
    const banner = this.querySelector('#waiting');
    const dest = document.querySelector('.b2b-apply-account');
    if (banner && dest) dest.insertAdjacentElement('afterbegin', banner);
  }

  showError(message) {
    const existing = this.form.querySelector('#login-form-error');
    if (existing) existing.remove();

    const html = `
      <div class="banner banner--error form__banner" id="login-form-error">
        <span class="banner__ribbon">!</span>
        <p class="banner__content">${message}</p>
      </div>`;
    
    this.form.insertAdjacentHTML('afterbegin', html);
    this.form.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  handleSubmit(event) {
		event.preventDefault();
		let isValid = true;
	
		// 1. Nettoyage des erreurs précédentes
		this.querySelectorAll('.is-invalid').forEach(el => el.classList.remove('is-invalid'));
	
		// 2. Validation
		const requiredInputs = this.form.querySelectorAll('[required]');
		
		requiredInputs.forEach(input => {
			const isCheckable = input.type === 'checkbox' || input.type === 'radio';
			const isEmpty = !input.value.trim();
			const isUnchecked = isCheckable && !input.checked;
	
			if (isEmpty || isUnchecked) {
				isValid = false;
				input.classList.add('is-invalid');
	
				// --- AJOUT : Supprimer l'erreur dès que l'utilisateur interagit ---
				const removeError = () => {
					input.classList.remove('is-invalid');
					input.removeEventListener('input', removeError);
					input.removeEventListener('change', removeError);
				};
	
				input.addEventListener('input', removeError);
				input.addEventListener('change', removeError);
				// -----------------------------------------------------------------
			}
		});
	
		if (!isValid) {
			this.showError(this.dataset.errorMessage || "Please complete all required fields.");
			return;
		}
	
		this.generateTags();
		this.form.submit();
	}

  generateTags() {
    const tags = ['b2b_pending'];
    // On récupère tous les inputs "fake" qui ont une valeur
    const proxyValues = this.querySelectorAll('[id^="fake-"]');
    
    proxyValues.forEach(input => {
      if (!input.value) return;

      // Cas spécial pour éclater les "interested_in:A,B" en "interested_in:A", "interested_in:B"
      if (input.id === 'fake-interested') {
        const val = input.value.replace('interested_in:', '');
        val.split(',').forEach(v => tags.push(`interested_in:${v}`));
      } else {
        tags.push(input.value);
      }
    });

    this.tagsInput.value = tags.join(',');
  }
}
customElements.define('register-form', RegisterForm);